import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";


import "../../../assets/topstudio/styles/CardsSprite.css";

import spriteUrl from "../../../assets/topstudio/styles/svg/sprite.css-d6f47756.svg";
import "../../../assets/topstudio/styles/Player.css";

export default function TeenpattiODI() {
  const [open, setOpen] = useState(false);

  const SUITS = ["S", "H", "D", "C"]; // Spades, Hearts, Diamonds, Clubs
  const RANKS = [
    "A",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "J",
    "Q",
    "K",
  ];
  const SUIT_BASE = { S: 0, H: 13, D: 26, C: 39 };

  function spriteIndexForCard({ suit, rank }) {
    const base = SUIT_BASE[suit];
    const rankIdx = RANKS.indexOf(rank);
    return base + rankIdx;
  }
  function classForCard(card) {
    const idx = spriteIndexForCard(card);
    return `open_cardTP sprite-card-chs-card svg-card_simple_${idx}-dims d-card RSMImageView2 svg-card_simple_${idx}`;
  }

  /** ---- Deck + helpers ---- **/
  function buildDeck() {
    const deck = [];
    for (const s of SUITS)
      for (const r of RANKS) deck.push({ suit: s, rank: r });
    return deck;
  }
  function shuffle(array) {
    const a = array.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = (Math.random() * (i + 1)) | 0;
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  /** ---- State ---- **/
  const DEAL_MS = 1000; // one card every 3s
  const [shoe, setShoe] = useState(() => shuffle(buildDeck()));
  const [playerA, setPlayerA] = useState([]); // Player A hand
  const [playerB, setPlayerB] = useState([]); // Player B hand
  const [step, setStep] = useState(0); // 0..6 (6 deals total)

  // timer display state (for base-timer circle)
  const [timeLeft, setTimeLeft] = useState(DEAL_MS); // ms left in the current 3s window
  const [tickId, setTickId] = useState(0); // increases each time a card is dealt (used to reset countdown)

  // refs for intervals/timeouts to clean up
  const dealIntervalRef = useRef(null);
  const countdownIntervalRef = useRef(null);
  const restartTimeoutRef = useRef(null);

  /** Start a fresh round and begin auto-dealing */
  function startRound() {
    // cleanup any prior timers
    clearInterval(dealIntervalRef.current);
    clearInterval(countdownIntervalRef.current);
    clearTimeout(restartTimeoutRef.current);

    setShoe((prev) => (prev.length < 10 ? shuffle(buildDeck()) : prev));
    setPlayerA([]);
    setPlayerB([]);
    setStep(0);
    setTimeLeft(DEAL_MS);
    setTickId((id) => id + 1);

    // 1) Deal a card every 3 seconds
    dealIntervalRef.current = setInterval(() => {
      setStep((prev) => prev + 1); // triggers the deal effect below
      setTickId((id) => id + 1); // resets countdown
      setTimeLeft(DEAL_MS);
    }, DEAL_MS);

    // 2) Countdown UI: update the circular timer ~10x/sec
    countdownIntervalRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev <= 100 ? DEAL_MS : prev - 100));
    }, 100);
  }

  /** Perform deal on each step: 1→A, 2→B, 3→A, 4→B, 5→A, 6→B; auto-restart after 6 */
  useEffect(() => {
    if (step === 0) return;

    setShoe((prevShoe) => {
      if (prevShoe.length === 0) return prevShoe;

      const [top, ...rest] = prevShoe;

      // 👇 change is here: give first 3 cards to A, next 3 to B
      const dealToA = step <= 3;

      if (dealToA) setPlayerA((h) => [...h, top]);
      else setPlayerB((h) => [...h, top]);

      // after sixth deal, stop intervals and schedule a fresh round
      if (step === 6) {
        clearInterval(dealIntervalRef.current);
        clearInterval(countdownIntervalRef.current);
        setTimeLeft(0);
        restartTimeoutRef.current = setTimeout(() => {
          startRound();
        }, DEAL_MS); // wait 3s, then new round
      }
      return rest;
    });
  }, [step]);

  /** Auto-start once on mount */
  useEffect(() => {
    startRound();
    return () => {
      clearInterval(dealIntervalRef.current);
      clearInterval(countdownIntervalRef.current);
      clearTimeout(restartTimeoutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** ---- SVG circular timer calculations ---- **/
  const R = 45; // circle r=45 (matches your SVG)
  const CIRC = 2 * Math.PI * R; // ~282.743
  const frac = Math.max(0, Math.min(1, timeLeft / DEAL_MS));
  const dash = Math.max(0.0001, CIRC * frac); // visible arc length
  const label = Math.ceil(timeLeft / 1000); // 3..2..1..

  return (
    <div className="aviator-scope player-scope">
      <ClientLayoutWithOutHeader>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="left-content">
                        <div className="cards-layout blackjack">
                          <div>
                            <div className="cards-layout blackjack">
                              <div className="col-12 timerDiv2">
                                <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                                    <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                                      <p>TEENPATTI ODI</p>
                                    </div>
                                    <div className="col-6 col-md-6 inline-block Gameidcol my-2 text-center">
                                      <div
                                        role="group"
                                        aria-label="Second group"
                                        className="btn-group btn-group-sm mr-2"
                                      >
                                        <button
                                          type="button"
                                          id="Alltab"
                                          className="tablink btn btn-primary bbactive"
                                          style={{ backgroundColor: "black" }}
                                        >
                                          Game
                                        </button>
                                        <button
                                          type="button"
                                          id="RESULTStab"
                                          className="tablink btn btn-primary"
                                        >
                                          Results
                                        </button>
                                        <button
                                          type="button"
                                          className="tablink btn btn-primary"
                                        >
                                          Rules
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                <div className="row mt-2">
                                  <div className="col-2 col-md-1">
                                    <div className="Connectedclients mt-1">
                                      <i
                                        aria-hidden="true"
                                        className="fa fa-user mr-1"
                                        style={{
                                          fontSize: "14px",
                                          color: "white",
                                        }}
                                      />
                                      <b>
                                        <span
                                          id="UsersCount"
                                          className="number"
                                        >
                                          326
                                        </span>
                                      </b>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-8" />

                                <div className="col-md-2">
                                  {/* Timer with animated stroke + numeric countdown */}
                                  <div
                                    className="base-timer"
                                    style={{ right: "0" }}
                                  >
                                    <svg
                                      viewBox="0 0 100 100"
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="base-timer__svg"
                                    >
                                      <g className="base-timer__circle">
                                        <circle
                                          cx="50"
                                          cy="50"
                                          r="45"
                                          className="base-timer__path-elapsed"
                                        ></circle>
                                        <path
                                          id="base-timer-path-remaining"
                                          /* dynamic arc based on timeLeft */
                                          strokeDasharray={`${Math.round(
                                            dash
                                          )} ${Math.round(CIRC)}`}
                                          d="
                                        M 50, 50
                                        m -45, 0
                                        a 45,45 0 1,0 90,0
                                        a 45,45 0 1,0 -90,0
                                      "
                                          className="base-timer__path-remaining red"
                                        ></path>
                                      </g>
                                    </svg>
                                    <span
                                      id="base-timer-label"
                                      className="base-timer__label"
                                    >
                                      {label}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              {/* Players */}
                              <div className="table-player">
                                {/* Player A */}
                                <div
                                  className="player"
                                  style={{ display: "inline-flex" }}
                                >
                                  <div className="player-item">
                                    <span className="name">Player A</span>
                                    <div className="player-card stood">
                                      <div className="header-title">
                                        <span className="status"></span>
                                      </div>
                                      <div
                                        id="BFBCardHandView"
                                        className="BFBCardHandView"
                                      >
                                        <div
                                          id="BFBCardFanView"
                                          className="BFBCardFanView tp-hand"
                                        >
                                          {playerA.slice(0, 3).map((c, i) => (
                                            <div key={i} className="tp-card">
                                              <div
                                                className={classForCard(c)}
                                                style={{
                                                  backgroundImage: `url(${spriteUrl})`,
                                                }}
                                              />
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <input
                                    id="AvxSoundcontrolA"
                                    type="checkbox"
                                    className="fa fa-volume-off fa-inverse sound-icon fa-2x"
                                    style={{
                                      width: "0px",
                                      top: "88%",
                                      marginRight: "8px",
                                    }}
                                  />
                                </div>

                                {/* Player B */}
                                <div
                                  className="player"
                                  style={{ display: "inline-flex" }}
                                >
                                  <div className="player-item">
                                    <span className="name">Player B</span>
                                    <div className="player-card stood">
                                      <div className="header-title">
                                        <span className="status"></span>
                                      </div>
                                      <div
                                        id="BFBCardHandView"
                                        className="BFBCardHandView"
                                      >
                                        <div
                                          id="BFBCardFanView"
                                          className="BFBCardFanView tp-hand"
                                        >
                                          {playerB.slice(0, 3).map((c, i) => (
                                            <div key={i} className="tp-card">
                                              <div
                                                className={classForCard(c)}
                                                style={{
                                                  backgroundImage: `url(${spriteUrl})`,
                                                }}
                                              />
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <input
                                    id="AvxSoundcontrolB"
                                    type="checkbox"
                                    className="fa fa-volume-off fa-inverse sound-icon fa-2x"
                                    style={{
                                      width: "0px",
                                      top: "88%",
                                      marginRight: "8px",
                                    }}
                                  />
                                </div>
                              </div>

                              {/* Controls removed (auto mode) */}
                            </div>
                          </div>
                        </div>

                        {/* Footer */}
                        <center>
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                            <div className="buttons-div">
                              {[
                                "A",
                                "A",
                                "A",
                                "A",
                                "B",
                                "B",
                                "B",
                                "A",
                                "A",
                                "B",
                              ].map((btn, idx) => (
                                <button
                                  key={idx}
                                  className="video-button border-gradient-btn border-gradient-purple-btn"
                                >
                                  {btn}
                                </button>
                              ))}
                            </div>
                            <div className="round-div">
                              <div className="label">Round ID:</div>
                              <div className="id">9001.68A37216</div>
                            </div>
                          </div>
                        </center>

                        {/* Market Sections (unchanged) */}
                        <div className="bg-white">
                          <div className="section-blur">
                            <div className="market-titlebar">
                              <p className="market-name">
                                <span className="market-name-badge">
                                  <i className="market-name-icon">
                                    <img
                                      src="/img/time.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px",
                                      }}
                                      alt=""
                                    />
                                  </i>{" "}
                                  <span>Main </span>
                                </span>
                              </p>
                              <div className="market-overarround">
                                <span></span>
                                <strong>Back</strong>
                              </div>
                              <div className="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>

                            <div className="market-runners">
                              <div className="runner-runner winner">
                                <h3 className="runner-name">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <h4
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        data-html="true"
                                        className="clippable-spacer"
                                      >
                                        Player A
                                      </h4>
                                    </span>
                                  </div>
                                  <div className="runner-position">
                                    <span>
                                      <span className="runner-position-pos">
                                        <strong></strong>
                                      </span>
                                    </span>
                                  </div>
                                </h3>
                                <div className="runner-disabled">
                                  Next Round !
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="section-blur">
                            <div className="market-titlebar">
                              <p className="market-name">
                                <span className="market-name-badge">
                                  <i className="market-name-icon">
                                    <img
                                      src="/img/time.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px",
                                      }}
                                      alt=""
                                    />
                                  </i>{" "}
                                  <span>Plus </span>
                                </span>
                              </p>
                              <div className="market-overarround">
                                <span></span>
                                <strong>Back</strong>
                              </div>
                              <div className="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>

                            <div className="market-runners">
                              <div className="runner-runner">
                                <h3 className="runner-name">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <h4
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        data-html="true"
                                        className="clippable-spacer"
                                      >
                                        Player A+
                                      </h4>
                                    </span>
                                  </div>
                                  <div className="runner-position">
                                    <span>
                                      <span className="runner-position-pos">
                                        <strong></strong>
                                      </span>
                                    </span>
                                  </div>
                                </h3>
                                <div className="runner-disabled">
                                  Next Round !
                                </div>
                              </div>
                            </div>

                            <div className="market-runners">
                              <div className="runner-runner">
                                <h3 className="runner-name">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <h4
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        data-html="true"
                                        className="clippable-spacer"
                                      >
                                        Player B+
                                      </h4>
                                    </span>
                                  </div>
                                  <div className="runner-position">
                                    <span>
                                      <span className="runner-position-pos">
                                        <strong></strong>
                                      </span>
                                    </span>
                                  </div>
                                </h3>
                                <div className="runner-disabled">
                                  Next Round !
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      {/* Right column (empty for now) */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>
    </div>
  );
}
